(function($) {

	var swiper = new Swiper('.swiper-container-desktop', {
		autoplay: 6000,
		effect: 'fade',
		nextButton: '#button-next-desktop',
		prevButton: '#button-prev-desktop',
		lazyLoading: true,
		loop: true,
		pagination: '.pagination-desktop',
		paginationClickable: true,

	});

	var swiperMobile = new Swiper('.swiper-container-mobile', {
		autoplay: 6000,
		effect: 'fade',
		nextButton: '#button-next-mobile',
		prevButton: '#button-prev-mobile',
		lazyLoading: true,
		loop: true,
		pagination: '.pagination-mobile',
		paginationClickable: true,

	});

})(jQuery);
